import { createClient, SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL as string | undefined
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY as string | undefined

let supabaseSingleton: SupabaseClient | null = null

export const getSupabaseClient = (): SupabaseClient => {
   if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
      throw new Error('Supabase env missing: define REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY')
   }
   if (!supabaseSingleton) {
      supabaseSingleton = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
   }
   return supabaseSingleton
}

const client = getSupabaseClient()
export default client


